import { render, staticRenderFns } from "./tags_search.vue?vue&type=template&id=0e61c08c&scoped=true"
import script from "./tags_search.vue?vue&type=script&lang=ts"
export * from "./tags_search.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e61c08c",
  null
  
)

export default component.exports